import { ActionIconDef, GridConfig } from '@inavista/components/grid';

// Out of Office request popup → reporter choice ("Sales Representatives") on @inavista/components. Rows: RIMS Master
// api/grid/vacation-requests/reporters (dbo.spGetEmployeesByManager's rows for the caller in the token, only for a role with
// popup_icon_selectResource). Same columns, labels, Select command, User Id link and toolbar as the Syncfusion grid it
// replaces. RIMS Sales only: the RIMS Service list (odata/ServiceEmployeesByManager) is not in RIMS Master on master.

export const SELECT_ACTION = 'select';

const SHOWN = ['userId', 'employeeName', 'territoryName', 'districtName', 'regionName', 'districtManager', 'regionManager'];
const ARROW_ICON = '<line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />';

export function reportersActionIcons(): ActionIconDef[] {
  return [{ key: SELECT_ACTION, label: 'Select', icon: ARROW_ICON, colorFn: () => '#000000de' }];
}

export function reportersGridConfig(masterApiUrl: string, sales: boolean, canExport: boolean): GridConfig {
  return {
    apiBaseUrl: `${masterApiUrl}grid/vacation-requests/reporters`,
    clientSide: true,
    keyColumn: 'userId',
    rowHeight: 26,
    loadingIndicator: 'banner',
    defaultColumnOrder: SHOWN,
    hiddenByDefaultColumns: ['userIdLN'],
    // ID was not in the column chooser.
    alwaysVisibleColumns: ['userId'],
    columnLabels: {
      userId: 'ID', employeeName: 'Name', territoryName: 'Territory', districtName: 'District', regionName: 'Region',
      districtManager: 'District Manager', regionManager: 'Region Manager',
    },
    // RIMS grid look: headers left; text left; the id centred.
    columnAlign: Object.fromEntries(SHOWN.map(c => [c, {
      header: { horizontal: 'left' as const }, ...(c === 'userId' ? { horizontal: 'center' as const } : {}),
    }])),
    columnWidths: {
      userId: 120, employeeName: 160, territoryName: 140, districtName: 140, regionName: 140, districtManager: 160, regionManager: 160,
    },
    stretchColumns: true,
    wrapHeaders: true,
    // The ID opens the user's profile.
    hyperlinkColumns: ['userId'],
    enableContextMenuFilter: true,
    enableSearch: true,
    enableFitColumns: true,
    enableResetLayout: true,
    enableSavedViews: false,
    // Excel for everyone but a Sales Rep, as before; the file is "Sales Representatives(<date>).xlsx" (it was named
    // "Warehouse Addresses", a copy from another popup).
    enableExport: canExport,
    defaultSort: { column: 'employeeName', direction: 'asc' },
    emptyStateMessage: sales
      ? 'No sales representatives to show. The list shows the people your role and territories give you access to.'
      : 'Choosing a reporter is not available in RIMS Service yet.',
    persistenceKey: 'rims.out-of-office.reporters',
    persistenceVersion: 1,
  };
}
